import BillingsOrderForwardBillingsDownloadRequest, {
  BillingsOrderForwardBillingsDownloadQueryParams,
} from "./billings-order-forward-billings-download.request";

const createQueryParams = (
  request: BillingsOrderForwardBillingsDownloadRequest,
): BillingsOrderForwardBillingsDownloadQueryParams => {
  return {
    consumer: request.consumer,
    human_id: request.humanId,
    order: request.order,
    producer: request.producer,
    start_time_since: request.startTimeSince,
    start_time_to: request.startTimeTo,
    status: request.status,
    taxi_corporation_id: request.taxiCorporationId,
  };
};

const billingsOrderForwardBillingsDownloadRequestFactory = {
  createQueryParams,
};

export default billingsOrderForwardBillingsDownloadRequestFactory;
